import { render, staticRenderFns } from "./ProductBar.vue?vue&type=template&id=b6f2639e&scoped=true&"
import script from "./ProductBar.vue?vue&type=script&lang=js&"
export * from "./ProductBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductBar.vue?vue&type=style&index=0&id=b6f2639e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f2639e",
  null
  
)

/* custom blocks */
import block0 from "./ProductBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSelect})
